import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { currentLocationModulesSelector } from 'state/ducks/auth'

const DispatchModuleConditional = ({ children, fallbackComponent }) => {
  const hasPermissions = (useSelector(currentLocationModulesSelector) || {}).canViewDispatch

  if (hasPermissions) return <>{children}</>

  if (fallbackComponent) return fallbackComponent

  return null
}

DispatchModuleConditional.propTypes = {
  children: PropTypes.element.isRequired,
  fallbackComponent: PropTypes.element,
}

DispatchModuleConditional.defaultProps = {
  fallbackComponent: undefined,
}

export default DispatchModuleConditional
